import { styled } from '@mui/material/styles';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

export const StyledTooltipWrapper = styled('span')(({ theme }) => ({
  display: 'inline',
  verticalAlign: 'text-bottom',
  [theme.breakpoints.down('md')]: {
    display: 'inline-flex',
  },
}));

export const StyledInfoIcon = styled(InfoOutlined)(({ theme }) => ({
  display: 'flex',
  color: theme.palette.neutral[600],
  marginLeft: '4px',
}));
